import * as React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useGetImageQuery } from "../../store/api/imageApi";
import { ImageDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org";
export const ImageDetailInitializer: React.FC = () => {
  const { org: orgName } = useParams<RouteParams>();
  const { pathname } = useLocation();

  const imageName = pathname.split(`/-`)[0].split(`/console/org/${orgName}/image/`)[1];
  console.log("image detail", imageName);

  const selfLink = `/org/${orgName}/image/${imageName}`;

  const { data: image, isLoading, isFetching, isError, error, refetch } = useGetImageQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!image && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="image" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !image) {
    return <IncorrectItem kind="image" canCreate={false} />;
  }

  return <ImageDetailForm image={image} />;
};
